import { ISupportQAItem } from "interfaces";
import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { formatNumber, isHaveActionPermission } from "utills/helpers";

interface SupportQACardProps {
  data?: ISupportQAItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const SupportQACard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: SupportQACardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: ISupportQAItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <SwitchButton
              checked={item.is_active}
              disabled={!isHaveActionPermission("support_qa", "cs", "edit")}
              onChange={() => _toggleActive(item.id, item.is_active)}
            />

            <div className="flex items-center gap-x-[8px]">
              <Link to={`/cs/support-qa/${item.id}`} className="w-fit">
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission("support_qa", "cs", "edit") ? (
                <Link to={`/cs/support-qa/${item.id}/edit`} className="w-fit">
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Q&A title vie</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.title_vi}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Category vie
            </p>
            <Link to={`/cs/support-category/${item.support_center_category_id}`} className="text-brand-500">
              <p className="flex-1 text-right text-sm leading-6">
                {item.support_center_category_name}
              </p>
            </Link>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Total View</p>
            <p className="flex-1 text-right text-sm leading-6">
              {formatNumber(item.total_views)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Likes</p>
            <p className="flex-1 text-right text-sm leading-6 capitalize">
              {formatNumber(item.total_likes)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Dislikes</p>
            <p className="flex-1 text-right text-sm leading-6 capitalize">
              {formatNumber(item.total_dislikes)}
            </p>
          </li>
        </div>
      ))}
    </ul>
  );
};
